/**
 *  CollapsiblePercentBars script file
**/

export default {
  name: 'CollapsiblePercentBars',
  mixins: [],
  components: {},
  props: {
    data: {
      type: Array,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    valueProp: {
      type: String,
      default: 'value'
    },
    keyProp: {
      type: String,
      default: 'key'
    },
    labelProp: {
      type: String,
      default: 'label'
    },
    symbol: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      currentLimit: this.limit
    }
  },
  computed: {
    max () {
      const values = this.data.map(d => d[this.valueProp])
      return Math.max(...values)
    }
  },
  methods: {
    toggle () {
      this.currentLimit = this.currentLimit === this.limit ? Infinity : this.limit
      this.$emit('toggle')
    }
  }
}
